export default "__VITE_ASSET__Ccjl9xo5__"